reflectGetProto